import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-payment-history',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './payment-history.component.html',
  styleUrl: './payment-history.component.scss'
})
export class PaymentHistoryComponent {
  payments = [
    {
      id: "TXN123456",
      date: "15.02.2026 14:30",
      type: "Paket alışı (10 elan)",
      amount: 29,
      status: "Success"
    }
  ];
}
